import { Component, OnInit } from '@angular/core';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-invalid-page',
  templateUrl: './invalid-page.component.html'
})
export class InvalidPageComponent implements OnInit {

  callbackURL : any;

  constructor() { }
  
  ngOnInit() {
    this.callbackURL = environment.callbackURL;
    // environment.callbackURL.forEach(element => {
    //   this.callbackURL.push(element);
    // })
  }

  isPRD():boolean{
    return environment.production;
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/misc/invalid-page/invalid-page.component.ts